import BaseAPI from '@/apis/base/baseApi';

class DevicesIssuesAPI extends BaseAPI {
	constructor() {
		super();
	}
	apiName = 'Business';
	controllerName = 'deviceIssues';
}

export default new DevicesIssuesAPI();
